/**
 * Returns the current width (in columns) of a widget from the active breakpoint layout.
 * Uses the layout that react-grid-layout updates when resizing.
 * @param {string} instanceId - Widget ID
 * @param {Object} layouts - { lg: [...], md: [...], ... }
 * @param {string} breakpoint - Active breakpoint
 * @param {number} [fallback] - Value if item is not found
 * @returns {number|undefined} Width in columns
 */
export const getWidgetLayoutWidth = (instanceId, layouts, breakpoint, fallback) => {
  const items = layouts?.[breakpoint];
  const item = items?.find((i) => i.i === instanceId);
  return item?.w ?? fallback;
};
